import { Paper } from "@mui/material";
import ModalForm from "App/Components/Modals/Components/ModalForm";
import Modal from "App/Components/Modals/Modal";
import Breadcrumb from "App/Components/Navigation/Breadcrumbs/Breadcrumbs";
import { PageContainer } from "App/Components/PageContainer/PageContainer";
import ListSkeleton from "App/Components/Skeleton/ListSkeleton";
import { RandomTextSkeleton } from "App/Components/Skeleton/RandomTextSkeleton";
import { useModalHooks } from "App/State/Hooks/useModalHooks";
import { FeatureFlags } from "App/Typings/FeatureFlags";
import { useFlags } from "launchdarkly-react-client-sdk";
import { useGetAttributeQuery } from "Pages/ABAC/AbacAppQueries";
import { useParams } from "react-router-dom";
import CreateAttributeForm from "../../../Attributes/Components/CreateAttributeForm";
import useCreateAttributeFormState from "../../../Attributes/State/CreateAttributeFormState";
import { AttributeDetailsForm } from "./Components/AttributeDetailsForm";

export function ManageAttribute() {
  const { appId, attributeId } = useParams<{
    appId: string;
    attributeId: string;
  }>();
  const { data: currentAttribute, isLoading } = useGetAttributeQuery(attributeId);

  // Initialize EnableABACApplicationManagement LD flag
  // TODO: Remove with ABAC-32
  const { enableAbacApplicationManagement } = useFlags<FeatureFlags>();

  const {
    getters: { createAttributeFormTitle, createIsLoading, formik },
    handlers: { handleCreateModalClose },
  } = useCreateAttributeFormState(appId, attributeId);

  const { modalStatus } = useModalHooks();

  if (!enableAbacApplicationManagement) {
    return null;
  }

  if (isLoading) {
    return (
      <PageContainer>
        <p>Loading...</p>
      </PageContainer>
    );
  }

  if (!isLoading && currentAttribute) {
    const manageFeatureBreadcrumbs = [
      {
        breadCrumbName: "ABAC Apps",
        route: `abac`,
      },
      {
        breadCrumbName: currentAttribute.app.name,
        route: `abac/${currentAttribute.app.id}`,
      },
    ];

    return (
      <PageContainer>
        <Breadcrumb
          pageTitle={currentAttribute.name}
          isLoading={isLoading}
          customBreadcrumbs={manageFeatureBreadcrumbs as any}
        />
        <h1 className="page-title">
          {!isLoading ? "Manage " + currentAttribute.name : <RandomTextSkeleton />}
        </h1>
        <Paper sx={{ mt: 4, p: { xs: 2, lg: 4 } }}>
          {!isLoading ? (
            <>
              <AttributeDetailsForm attribute={currentAttribute} />
            </>
          ) : (
            <ListSkeleton numRows={5} />
          )}
        </Paper>
        <Modal
          fullWidth
          maxWidth="sm"
          open={modalStatus.open === true}
          title={createAttributeFormTitle}
          hasLoadingBar={true}
          isProcessing={createIsLoading}
          handleClose={() => handleCreateModalClose()}
        >
          <ModalForm formik={formik} isProcessing={createIsLoading}>
            <CreateAttributeForm />
          </ModalForm>
        </Modal>
      </PageContainer>
    );
  }
}
